import React, { ReactNode } from "react";
import { Form } from "react-bootstrap";
import { CustomLabel } from "./CustomLabel";
import { InputErrorMessage } from "./InputErrorMessage";
import { Controller, Control, UseFormRegister, UseFormSetValue } from "react-hook-form";

type TextAreaWithoutValidationProps = {
  usarValidacaoParaFormulario: false;
};

type TextAreaWithValidationProps = {
  usarValidacaoParaFormulario: true;
  /**Nome do atributo que será usado no formulario para realizar as validacoes*/
  name: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
};

type TextAreaProps = {
  id: string;
  label?: string;
  placeholder?: string;
  className?: string;
  direcaoExpansao: "both" | "horizontal" | "vertical" | "none";
  qtdLinhas?: number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: string;
} & (TextAreaWithoutValidationProps | TextAreaWithValidationProps);

const CustomTextArea: React.FC<TextAreaProps> = (props) => {
  const classNameResize = `resize-${props.direcaoExpansao}`;

  const renderTextAreaComValidacao = (): ReactNode => {
    if (props.usarValidacaoParaFormulario) {
      return (
        <Controller
          name={props.name}
          control={props.control}
          defaultValue={props.defaultValue}
          render={({ field, fieldState }) => (
            <>
              {props.label && <CustomLabel possuiErro={fieldState.error != null}>{props.label}</CustomLabel>}
              <Form.Control
                {...props.register(props.name)}
                {...field}
                as="textarea"
                id={props.id}
                value={field.value || ""}
                className={`input-gc ${classNameResize}`}
                placeholder={props.placeholder || ""}
                rows={props.qtdLinhas}
                isInvalid={fieldState.error != null}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  field.onChange(event);
                  props.setValue(props.name, event.target.value);

                  props.onChange && props.onChange(event);
                }}
              />
              {fieldState.error && <InputErrorMessage>{fieldState.error.message}</InputErrorMessage>}
            </>
          )}
        />
      );
    }
  };

  const renderTextAreaSemValidacao = (): ReactNode => {
    if (!props.usarValidacaoParaFormulario) {
      return (
        <div>
          {props.label && <CustomLabel possuiErro={false}>{props.label}</CustomLabel>}
          <Form.Control
            as="textarea"
            id={props.id}
            className={`input-gc ${classNameResize}`}
            placeholder={props.placeholder || ""}
            rows={props.qtdLinhas}
            defaultValue={props.defaultValue}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.onChange && props.onChange(event)}
          />
        </div>
      );
    }
  };

  return (
    <div className={props.className || ""}>
      {props.usarValidacaoParaFormulario && renderTextAreaComValidacao()}
      {!props.usarValidacaoParaFormulario && renderTextAreaSemValidacao()}
    </div>
  );
};

export default CustomTextArea;
